export const MUDAD_INVOICE_GENERATED_LOAD = 'MUDAD_INVOICE_GENERATED_LOAD'
export const MUDAD_INVOICE_GENERATED_LOAD_PENDING = 'MUDAD_INVOICE_GENERATED_LOAD_PENDING'
export const MUDAD_INVOICE_GENERATED_LOAD_FULFILLED = 'MUDAD_INVOICE_GENERATED_LOAD_FULFILLED'
export const MUDAD_INVOICE_GENERATED_LOAD_REJECTED = 'MUDAD_INVOICE_GENERATED_LOAD_REJECTED'
